export const HOST = "https://api.minilist.app"
// export const HOST = "https://minilist-api.tunnelto.dev"
// export const HOST = "https://dev-api.minilist.app"